import { Channel, ChannelColorMap } from "../types/type/review"

export const getChannelInitial = (channel: Channel): string => {
  return channel.charAt(0).toUpperCase()
}

export const getChannelColor = (channel: Channel): string => {
  return ChannelColorMap[channel] || "#95A5A6"
}
